module.exports = __webpack_public_path__ + "static/overview.f1593031.svg";